import { URL_BASE_REEMBOLSOS } from "../../constants/url";
import { composeErrorNotification, composeSuccessNotification } from "../../utils/composeNotification";
import { post } from "../../utils/fetch";
import { startLoadAsistencia } from "./detalleActions";
import { notification } from "./notificationActions";

export const startSolicitarReembolso = (body) => {
    return async (dispatch) => {
        const result = await post(`${URL_BASE_REEMBOLSOS}/SolicitarReembolso`, body)
        if (result.code === 0) {
            dispatch(startLoadAsistencia(body.asistenciaID))
            dispatch(notification(composeSuccessNotification("Reembolso creado")))
            return true
        } else {
            dispatch(notification(composeErrorNotification(`${result.error}`)))
            return false
        }
    }
}